class LogicError extends Error {
  constructor(message, code) {
    super();
    this.message = message;
    this.code = code;
    this.stack = null;
  }
}

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
    } else {
        return Promise.reject(new Error(`An error occurred in the request: ${response.status} - ${response.statusText}`))
    }
}

function toJson(response) {
    return response.json()
}

export default function fetchClient(path, params={}) {
    /**
     * объект params содержит два ключа
     * queryParams - объект query параметров запроса, преобразуется в строку
     * fetchData - опции для fetch
     *
     * Пример:
     * params = {
     *   queryParams: {
     *      category_id: 12,
     *      search: 'мрт',
     *      page: 1
     *   },
     *   fetchData: {
     *     method: 'post',
     *     headers: {
     *       "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
     *     },
     *     body: 'foo=bar&lorem=ipsum'
     *   }
     * }
     * */
    const originUrl = window.location.origin
    const apiPath = '/api/v3'
    const { queryParams = {}, fetchData = {} } = params
    const queryString = Object.keys(queryParams).length > 0
        ? '?' + new URLSearchParams(queryParams).toString()
        : ''

    const fullUrl = `${originUrl}${apiPath}${path}${queryString}`

    return fetch(fullUrl, fetchData)
        .then(checkStatus)
        .then(toJson)
        .then(data => {
            if (data.status === 'success') {
                return data.message;
            } else if (data.status === 'error') {
                return Promise.reject(new LogicError(data.message, data.code))
            } else {
                return Promise.reject(new Error(`API Error! url: ${fullUrl}; fetchData: ${fetchData}`))
            }
        })
}